module.exports = __webpack_public_path__ + "img/lv1_3_1.53826475.png";